
export default {
  inheritAttrs: false,
  props: {
    current: {
      type: String,
      default: null
    }
  },
  vessel: {
    list: {
      borderLeftWidth: 1,
      borderColor: 'black',
      color: 'black',
      fontSize: 'lg',
      font: 'serif'
    },
    link: {
      paddingLeft: 'sm',
      fontWeight: 'semibold'
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    const items = await $content(locale, 'menus')
      .only(['name', 'slug'])
      .sortBy('id')
      .fetch()

    this.categories = items
  },
  data() {
    return {
      categories: null
    }
  },
  methods: {
    itemLink({ name, slug }) {
      const link = this.$pagePath({
        name: 'the-menu-id',
        query: { source: this.$route.query.source },
        params: { id: slug }
      })

      return name == this.current ? null : link
    },
    itemColor({ name }) {
      return name == this.current ? 'grey-darker' : 'black'
    }
  }
}
